import { Title, usePageTitle } from "~/shared";
import HighlightedText from "~/ui/common/HighlightedText";
import {
  AccountInformation,
  ClinicalCare,
  InsuranceCoverage,
  MessageProvider,
} from "./components";

export const ContactUs = () => {
  usePageTitle("Contact Us");

  return (
    <div className="font-sans">
      <header className="mb-8">
        <Title>
          <HighlightedText>Contact us</HighlightedText>
        </Title>
      </header>

      <section className="grid grid-cols-1 gap-6 font-sans md:grid-cols-2">
        <ClinicalCare />
        <AccountInformation />
        <InsuranceCoverage />
        <MessageProvider />
      </section>
    </div>
  );
};
